import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';

const ListingLinkMore = ({
  linkTitle,
  linkHref,
  isEditMode,
}) => {
  let href = linkHref?.[0]?.['@id'] || '';

  return href && (
    <div className="footer">
      <UniversalLink href={isEditMode ? '#' : flattenToAppURL(href)}>
        {linkTitle || href}
      </UniversalLink>
    </div>
  );
};
ListingLinkMore.propTypes = {
  linkHref: PropTypes.any,
  isEditMode: PropTypes.bool,
};
export default ListingLinkMore;
